import { buildSelectedTargetSummary, extractSelectedTargetFromContext } from "../selectedTarget";

function asTrimmedString(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function buildBridgeMessagePrefix(context?: Record<string, unknown>): string {
  if (!context) return "";
  const hasExplicitSelectedTarget =
    !!context.selectedTarget &&
    typeof context.selectedTarget === "object" &&
    !Array.isArray(context.selectedTarget);
  const selectedTarget = hasExplicitSelectedTarget
    ? extractSelectedTargetFromContext(context)
    : undefined;
  if (selectedTarget?.label) {
    return `[about: ${selectedTarget.label}] `;
  }
  if (context.presenceContext) {
    return "[from notification] ";
  }
  const lifeItemLabel = asTrimmedString(context.lifeItemLabel);
  if (lifeItemLabel) {
    return `[re: ${lifeItemLabel}] `;
  }
  const uiElementLabel = asTrimmedString(context.uiElementLabel);
  if (uiElementLabel) {
    return `[about: ${uiElementLabel}] `;
  }
  return "";
}

export function buildBridgeContextSummary(context?: Record<string, unknown>): string | undefined {
  if (!context) return undefined;

  const explicitSummary = asTrimmedString(context.contextSummary);
  const selectedTarget = extractSelectedTargetFromContext(context);
  const selectedTargetSummary = buildSelectedTargetSummary(selectedTarget);
  if (explicitSummary) {
    if (!selectedTargetSummary || explicitSummary.includes(selectedTargetSummary)) {
      return explicitSummary;
    }
    return `${explicitSummary} ${selectedTargetSummary}`;
  }

  const parts: string[] = [];
  const uiElementLabel = asTrimmedString(context.uiElementLabel);
  const screenLabel =
    asTrimmedString(context.workspaceSurfaceLabel) ?? asTrimmedString(context.sidebarNodeLabel);
  const uiSurface = asTrimmedString(context.uiSurface);
  const appTitle = asTrimmedString(context.appTitle);
  const digestSummary = asTrimmedString(context.workspaceDigestSummary);

  if (uiElementLabel) {
    parts.push(`Selected element: ${uiElementLabel}.`);
  }
  if (screenLabel) {
    parts.push(`Current workspace area: ${screenLabel}.`);
  }
  if (appTitle) {
    parts.push(`Open app: ${appTitle}.`);
  }
  if (uiSurface) {
    parts.push(`UI surface: ${uiSurface}.`);
  }
  if (digestSummary) {
    parts.push(`Workspace summary: ${digestSummary}`);
  }
  if (selectedTargetSummary) {
    parts.push(selectedTargetSummary);
  }

  return parts.length > 0 ? parts.join(" ") : undefined;
}
